import type { FunctionComponent } from "react";
import { graphql, useFragment } from "react-relay";

import { article as articleData, section as sectionData } from "~/data";
import type { sectionTagSeriesArticleArticle$key } from "~/queries/__generated__/sectionTagSeriesArticleArticle.graphql";

import { Container } from "./styles";

export type Props = {
  className?: string;
  reference: sectionTagSeriesArticleArticle$key;
};

export const SeriesArticleSectionTag: FunctionComponent<Props> = ({ className, reference }) => {
  const seriesArticle = useFragment(
    graphql`
      fragment sectionTagSeriesArticleArticle on Article {
        sections {
          value {
            entityId
            name
          }
        }
        types {
          value {
            entityId
          }
        }
      }
    `,
    reference,
  );

  const seriesArticleSections =
    seriesArticle?.sections?.flatMap(sections => sections?.value ?? []) ?? [];

  const getSeriesItemSectionTag = () => {
    const seriesArticleSectionsIds = new Set(
      seriesArticleSections.map(seriesArticleSection => seriesArticleSection?.entityId ?? ""),
    );

    const articleTypeIds =
      seriesArticle?.types?.flatMap(
        types => types?.value?.map(value => value?.entityId ?? "") ?? [],
      ) ?? [];

    if (articleTypeIds.includes(articleData.types.seriesDefaultLabel.entityId)) {
      return "SCMP Series";
    }

    if (seriesArticleSectionsIds.has(sectionData.thisWeekInAsia.entityId)) {
      return "This Week in Asia Series";
    }

    if (seriesArticleSectionsIds.has(sectionData.magazine.entityId)) {
      return `${seriesArticleSections[1]?.name ?? ""} Series`;
    }

    if (
      seriesArticleSectionsIds.has(sectionData.news.entityId) ||
      seriesArticleSectionsIds.has(sectionData.comment.entityId)
    ) {
      return `SCMP ${seriesArticleSections[1]?.name ?? ""} Series`;
    }

    return `SCMP ${seriesArticleSections[0]?.name ?? ""} Series`;
  };

  return <Container className={className}>{getSeriesItemSectionTag()}</Container>;
};

SeriesArticleSectionTag.displayName = "SeriesArticleSectionTag";
